import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "./ui/input";
import { api, errMsg, money } from "../lib/api";

const thisMonth = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; };

export const MarketerSales = () => {
  const [month, setMonth] = useState(thisMonth());
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!/^\d{4}-\d{2}$/.test(month)) return;
    api.get("/stats/marketers", { params: { month } }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [month]);
  const max = Math.max(...rows.map((r) => r.total), 1);
  const sum = rows.reduce((s, r) => s + r.total, 0);

  return (
    <div className="mt-12">
      <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-display text-lg font-semibold">Plasiyer Aylık Satışları</h2>
          <p className="text-sm text-slate-500">Toplam: <b data-testid="marketer-sales-sum">{money(sum)}</b> (iptaller hariç)</p>
        </div>
        <Input data-testid="marketer-sales-month-input" type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="h-10 w-44 bg-white" />
      </div>
      <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white shadow-sm">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left font-mono text-[11px] uppercase tracking-wider text-slate-500">
            <tr><th className="p-4">Plasiyer</th><th className="p-4 text-right">Sipariş</th><th className="p-4">Toplam Satış</th><th className="p-4 text-right">Tahsil Edilen</th><th className="p-4 text-right">Açık Cari</th></tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={5} className="p-10 text-center text-slate-500" data-testid="marketer-sales-empty">Plasiyer yok</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`marketer-sales-row-${r.id}`} className="border-t border-slate-100">
                <td className="p-4 font-semibold">{r.name}</td>
                <td className="p-4 text-right">{r.count}</td>
                <td className="p-4 min-w-[220px]">
                  <div className="flex items-center gap-3">
                    <div className="h-2 flex-1 overflow-hidden rounded-full bg-slate-100"><div className="h-full rounded-full bg-blue-600 transition-[width] duration-500" style={{ width: `${(r.total / max) * 100}%` }} /></div>
                    <span className="w-28 text-right font-display font-bold whitespace-nowrap" data-testid={`marketer-sales-total-${r.id}`}>{money(r.total)}</span>
                  </div>
                </td>
                <td className="p-4 text-right text-emerald-700 whitespace-nowrap">{money(r.paid)}</td>
                <td className="p-4 text-right text-rose-700 whitespace-nowrap">{money(r.unpaid)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
